/** USD value for when to prefer amount over speed when selecting a route. */
export const DYNAMIC_ROUTING_THRESHOLD = 10000;
